import { render, staticRenderFns } from "./learningUsCourse.vue?vue&type=template&id=466c6798&"
import script from "./learningUsCourse.vue?vue&type=script&lang=ts&"
export * from "./learningUsCourse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports